export const integerOrNull = (num) => {
  return (num !== undefined && num === null) || isNaN(num)
    ? null
    : parseInt(num);
};
